import React from 'react'
import { Dialog, DialogTitle, DialogContent, DialogContentText, Box } from '@material-ui/core'

import PaymentSelect from '../PaymentSelect'

export default function DialogPaymentSelect({ open, team, onClose }) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Payment Methods</DialogTitle>
      <DialogContent>
        <Box maxWidth="400px" mb={3}>
          <DialogContentText>
            Available payment methods for your team account are listed below. These payment methods
            are visible to all admin members.
          </DialogContentText>
        </Box>

        <PaymentSelect team={team} />
      </DialogContent>
    </Dialog>
  )
}
